import React, { useState } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Form,
} from "reactstrap"
import { Link } from "react-router-dom";
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import ModalVideo from "react-modal-video"
import "react-modal-video/scss/modal-video.scss"

// import image
import img1 from "../../assets/images/small/img-1.jpg"
import img2 from "../../assets/images/small/img-2.jpg"
import img3 from "../../assets/images/small/img-3.jpg"
import img4 from "../../assets/images/small/img-4.jpg"
import img5 from "../../assets/images/small/img-5.jpg"
import img6 from "../../assets/images/small/img-6.jpg"
import img7 from "../../assets/images/small/img-7.jpg"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

const images = [img1, img2, img3, img4, img5, img6]
const images1 = [img3, img7];

const UiLightbox = (props) => {

  document.title = " Lightbox | Minible - Responsive Bootstrap 5 Admin Dashboard"

  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isEffects, setisEffects] = useState(false);
  const [photoIndex, setphotoIndex] = useState(0);
  const [isGallery, setisGallery] = useState(false);
  const [isFits, setisFits] = useState(0);
  const [isGalleryZoom, setisGalleryZoom] = useState(false);
  const [isOpen, setisOpen] = useState(false)
  const [isOpen1, setisOpen1] = useState(false)
  const [modal, setmodal] = useState(false)
  const [map, setMap] = useState(false);
  function tog_map() {
    setMap(!map);
  }

  const containerStyle = {
    width: '100%',
    height: '300px',
  };

  const center = {
    lat: 37.778519, lng: -122.40564
  };

  const selectedPlace = {};

  const [selected, setSelected] = useState(null);

  const onSelect = (marker) => {
    setSelected(marker);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="UI Elements" breadcrumbItem="Lightbox" />
          {open && (
            <Lightbox
              open={open}
              close={() => setOpen(false)}
              index={currentIndex}
              slides={images.map((image) => ({ src: image }))}
            />
          )}

          {isEffects && (
            <Lightbox
              open={isEffects}
              close={() => setisEffects(false)}
              index={currentIndex}
              slides={images.map((image) => ({ src: image }))}
            />
          )}


          {isGallery && (
            <Lightbox
              open={isGallery}
              close={() => setisGallery(false)}
              index={photoIndex}
              slides={images.map((image) => ({ src: image }))}
            />
          )}

          {isGalleryZoom && (
            <Lightbox
              open={isGalleryZoom}
              close={() => setisGalleryZoom(false)}
              index={isFits}
              slides={images1.map((image) => ({ src: image }))}
            />
          )}


          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">Single image lightbox</CardTitle>
                  <p className="card-title-desc">
                    Three simple popups with different scaling settings.
                  </p>
                  <Row>
                    <Col className="col-6">
                      <div>
                        <h5 className="mt-0 font-size-14">Fits (Horz/Vert)</h5>
                        <Link className="image-popup-vertical-fit" to="#">
                          <img
                             onClick={() => {
                              setOpen(true);
                              setCurrentIndex(1);
                            }}
                            className="img-fluid"
                            alt="Minible"
                            src={img2}
                            width="145"
                          />
                        </Link>
                      </div>
                    </Col>
                    <Col className="col-6">
                      <div>
                        <h5 className="mt-0 font-size-14">Effects</h5>
                        <Link className="image-popup-no-margins" to="#">
                          <img
                            onClick={() => {
                              setisEffects(true);
                              setCurrentIndex(2);
                            }}
                            className="img-fluid"
                            alt=""
                            src={img3}
                            width="75"
                          />
                        </Link>
                        <p className="mt-2 mb-0 text-muted">
                          No gaps, zoom animation, close icon in top-right
                          corner.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">Lightbox gallery</CardTitle>
                  <p className="card-title-desc mb-1">
                    In this example lazy-loading of images is enabled for the
                    next image based on move direction.{" "}
                  </p>
                  <div className="popup-gallery">
                    <Row>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img1}
                              onClick={() => {
                                setisGallery(true)
                                setisFits(0);
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img2}
                              onClick={() => {
                                setisGallery(true)
                                setphotoIndex(1)
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img3}
                              onClick={() => {
                                setisGallery(true)
                                setphotoIndex(2)
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img4}
                              onClick={() => {
                                setisGallery(true)
                                 setisFits(0);
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img5}
                              onClick={() => {
                                setisGallery(true)
                                setphotoIndex(4)
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xl={2} md={4} className="col-6">
                        <div className="mt-4">
                          <div className="img-fluid">
                            <img
                              src={img6}
                              onClick={() => {
                                setisGallery(true)
                                setphotoIndex(5)
                              }}
                              alt=""
                              className="img-fluid d-block cursor-pointer"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">Zoom Gallery</CardTitle>
                  <p className="card-title-desc">
                    Zoom effect works only with images.
                  </p>

                  <div className="zoom-gallery">
                    <img
                      src={img3}
                      className="float-left cursor-pointer"
                      onClick={() => {
                        setisGallery(true)
                        setphotoIndex(2)
                      }}
                      alt=""
                      width="275"
                    />
                    <img
                      src={img7}
                      className="float-left cursor-pointer"
                      onClick={() => {
                        setisGallery(true)
                        setphotoIndex(4)
                      }}
                      alt=""
                      width="275"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">Popup with video or map</CardTitle>
                  <p className="card-title-desc">
                    In this example lazy-loading of images is enabled for the
                    next image based on move direction.{" "}
                  </p>

                  <Row>
                    <Col>
                      <div className="d-flex flex-wrap gap-2">
                        <Button
                          className="btn btn-light"
                          color="light"
                          onClick={() => {
                            setisOpen(!isOpen)
                          }}
                        >
                          Open YouTube Video
                        </Button>{" "}
                        <Button
                          className="btn btn-light"
                          color="light"
                          onClick={() => {
                            setisOpen1(!isOpen1)
                          }}
                        >
                          Open Vimeo Video
                        </Button>{" "}
                        <ModalVideo
                          videoId="L61p2uyiMSo"
                          channel="youtube"
                          isOpen={isOpen}
                          onClose={() => {
                            setisOpen(!isOpen)
                          }}
                        />
                        <ModalVideo
                          videoId="L61p2uyiMSo"
                          channel="youtube"
                          isOpen={isOpen1}
                          onClose={() => {
                            setisOpen1(false)
                          }}
                        />
                        <Button
                          className="btn btn-light"
                          color="light"
                          onClick={() => {
                            tog_map()
                          }}
                        >
                          Open Google Map
                        </Button>
                      </div>
                      <Modal
                        centered
                        isOpen={map}
                        size="lg"
                        toggle={() => {
                          tog_map()
                        }}
                      >
                        <ModalHeader toggle={tog_map}>
                          Google Map
                        </ModalHeader>
                        <ModalBody>
                          <div
                            id="gmaps-markers"
                            className="gmaps"
                            style={{ position: "relative" }}
                          >
                            <LoadScript googleMapsApiKey="AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE">
                              <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
                                <Marker position={center} onClick={() => onSelect(center)} />
                                {selected && (
                                  <InfoWindow
                                    position={selected}
                                    onCloseClick={() => setSelected(null)}
                                  >
                                    <div>
                                      <h1>{selectedPlace.name}</h1>
                                    </div>
                                  </InfoWindow>
                                )}
                              </GoogleMap>
                            </LoadScript>
                          </div>
                        </ModalBody>
                      </Modal>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Popup with form</h4>
                  <div>
                    <Link
                      onClick={() => {
                        setmodal(!modal)
                      }}
                      to="#"
                      className="popup-form btn btn-primary"
                    >
                      Popup form
                    </Link>
                  </div>

                  <Modal
                    size="lg"
                    className="text-center"
                    isOpen={modal}
                    toggle={() => {
                      setmodal(!modal)
                    }}
                    centered={true} >
                    <ModalHeader
                      className="mb-4"
                      toggle={() => {
                        setmodal(!modal)
                      }}
                    >
                      Form
                    </ModalHeader>
                    <ModalBody>
                      <Form>
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="name">Name</label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Enter Name"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="email">Email</label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                placeholder="Enter Email"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="password">Password</label>
                              <input
                                type="password"
                                className="form-control"
                                id="password"
                                placeholder="Enter Password"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="subject">Subject</label>
                              <textarea
                                className="form-control"
                                id="subject"
                                rows="3"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className="text-end">
                              <button type="submit" className="btn btn-primary">
                                Submit
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UiLightbox